import { render, staticRenderFns } from "./FairPayPromoPage.vue?vue&type=template&id=4868ebe6&scoped=true"
import script from "./FairPayPromoPage.vue?vue&type=script&setup=true&lang=js"
export * from "./FairPayPromoPage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FairPayPromoPage.vue?vue&type=style&index=0&id=4868ebe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4868ebe6",
  null
  
)

export default component.exports